import { render, staticRenderFns } from "./employeeDashboard.vue?vue&type=template&id=06056ec8&scoped=true"
import script from "./employeeDashboard.vue?vue&type=script&lang=js"
export * from "./employeeDashboard.vue?vue&type=script&lang=js"
import style0 from "./employeeDashboard.vue?vue&type=style&index=0&id=06056ec8&prod&scoped=true&lang=css"
import style1 from "./employeeDashboard.vue?vue&type=style&index=1&id=06056ec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06056ec8",
  null
  
)

export default component.exports